import { createClient, type SupabaseClient } from "@supabase/supabase-js";

// Browser Supabase client — uses the PUBLISHABLE key + the signed-in user's JWT,
// so all reads/writes are constrained by row-level security. Never put the
// service_role key here; that stays server-side in apps/api.
const url = import.meta.env.VITE_SUPABASE_URL;
const publishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

let client: SupabaseClient | null = null;

export function getSupabase(): SupabaseClient {
  if (!url || !publishableKey) {
    throw new Error(
      "Missing VITE_SUPABASE_URL / VITE_SUPABASE_PUBLISHABLE_KEY. " +
        "Copy the two VITE_ values from .env into apps/web/.env.local.",
    );
  }
  if (!client) {
    client = createClient(url, publishableKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        // PKCE: the OAuth redirect returns a `?code=...` we exchange explicitly
        // in the /auth/callback route (detectSessionInUrl off so the exchange is
        // deterministic and we can upsert the profile right after).
        flowType: "pkce",
        detectSessionInUrl: false,
      },
    });
  }
  return client;
}

// True when the browser client is configured (used by the shell to avoid
// crashing before the owner wires the env values).
export const supabaseConfigured = Boolean(url && publishableKey);
